<template>
  <van-dropdown-menu direction="up" class="lang-menu">
      <van-dropdown-item :title=" $t('append_field.more')" >
        <van-cell style="color: #409eff" center :title=" $t('append_field.reset_password')" @click="handleSetMore(1)">
        </van-cell>
        <van-cell style="color: #409eff" center :title=" $t('append_field.register')" @click="handleSetMore(2)" v-if="registerUser === '1'">
        </van-cell>
<!--        <van-cell style="color: #409eff" center :title=" $t('append_field.register')" @click="handleSetMore(3)" >
        </van-cell>-->
      </van-dropdown-item>
  </van-dropdown-menu>
</template>
<script>


import qs from "qs";
import {Toast} from "vant";

export default {
  name: 'MoreSelect',
  props: {
    userName: {
      type: String,
      required: true
    },
    registerUser:{
      type: String,
      required: true
    }
  },


  methods: {
    handleSetMore(type) {
      switch (type){
        case 1:
          this.goToResetPasswordPage()
          break
        case 2:
          this.$router.push('/Register')
          break
        /* case 3:
           this.$router.push({path: '/Help',query:{lang:'zh'}})
          break*/
      }

    },
    goToResetPasswordPage(){
      if(this.userName){
        this.$ajax.post("/etv/getSimpleInfo.json", qs.stringify({
          account: this.userName
        })).then(res => {
          if (res.data.code === 0) {
            const { email, phone} = res.data.data
            // 定义跳转逻辑，例如使用Vue Router或修改window.location
            this.$router.push({path: '/resetPwd', query:{username:this.userName,email,phone}})
          }else{
            Toast(res.data.msg,'fail')
          }
        })

      }else{
        Toast(this.$t('append_field.enter_account'),'fail')
      }
    },

  }
}
</script>
<style scoped lang="scss">
.lang-menu{
  ::v-deep .van-dropdown-menu__bar{
    background: none;
    box-shadow:none;
  }
  ::v-deep .van-ellipsis{
    font-size:  15px;
  }
}
</style>